import SvgIcon from '@mui/material/SvgIcon';
import * as React from 'react';
const SvgXmark = (props)=>/*#__PURE__*/ React.createElement(SvgIcon, {
        ...props,
        viewBox: "0 0 24 24"
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M16.828 15.723a.74.74 0 0 1 0 1.058.77.77 0 0 1-1.078 0L12 13.071 8.225 16.78a.77.77 0 0 1-1.077 0 .74.74 0 0 1 0-1.058l3.778-3.708-3.78-3.737a.74.74 0 0 1 0-1.058.77.77 0 0 1 1.078 0l3.778 3.738 3.776-3.709a.77.77 0 0 1 1.077 0 .74.74 0 0 1 0 1.058l-3.778 3.708z"
    }));
export default SvgXmark;
